export const USER_PROFILE_LICENSE_LIMITS_REQUEST = 'USER_PROFILE_LICENSE_LIMITS_REQUEST'
export const USER_PROFILE_MONITORING_STATS_REQUEST = 'USER_PROFILE_MONITORING_STATS_REQUEST'
export const USER_PROFILE_PORTFOLIO_STATS_REQUEST = 'USER_PROFILE_PORTFOLIO_STATS_REQUEST'
export const USER_PROFILE_DISTRAINTS_STATS_REQUEST = 'USER_PROFILE_DISTRAINTS_STATS_REQUEST'

export const LOCALE_PREFIX = 'components.Dialog.components.UserProfile.components.Content.components.GeneralSettings'
